
    <div [formGroup]="form">

      <select formControlName="durata" class="form-control">
        <option value="0.5">30 minuti</option>
        <option value="0.75">45 minuti</option>
        <option value="1">1 ora</option>
        <option value="1.25">1 ora e 15 min</option>
        <option value="1.5">1 ora e mezza</option>
        <option value="-1">Durata personalizzata</option>
      </select>

      <div class="d-flex align-items-center mt-2" *ngIf="form.value.durata < 0 || form.value.durata > 2" style="width: 100%">
        <div class="mr-2">Indica la durata: </div>
        <div class="field-durata">
          <div class="select-container _hours mr-1" style="width: 20px">

            {{ form.value.hours }}

            <select formControlName="hours">
              <option disabled>Ore:</option>
              <option [value]="2">2</option>
              <option [value]="3">3</option>
              <option [value]="4">4</option>
            </select>
          </div>
          <div style="padding-top: 5px">:</div>
          <div class="select-container ml-1">

            {{ showMinutes(form.value.minutes) }}

            <select formControlName="minutes">
              <option disabled>Minuti:</option>
              <option [value]="0">00</option>
              <option [value]="0.25">15</option>
              <option [value]="0.5">30</option>
              <option [value]="0.75">45</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  